module.exports = __webpack_public_path__ + "static/media/beauty-fitness.9807cb34.svg";